const ServiceEn = {
    subTitle: {
        1: "Application Services",
        content1: "We combine deep business acumen with technical expertise to deliver tailored system integrations, collaborating closely with your teams to architect scalable solutions from concept to implementation.",
        2: "Consulting Services",
        content2: "Your growth is our expertise. Blueshine's seasoned consultants become an extension of your team, aligning process improvements, talent development, and system upgrades to create synchronized organizational transformation. We succeed when you surpass your strategic objectives.",
        3: "Transformation Services",
        content3: "We customize every solution to your organization's unique objectives, offering flexible implementation options. Whether deployed individually or combined for comprehensive impact, our approaches deliver lasting transformation that evolves with your business.",
        4: "e-Commerce",
        content4: "Blueshine leads in e-commerce strategy and SAP Hybris implementation, leveraging mobility, cloud, social media, big data, analytics and AI to transform customer experiences",
        5: "Recruitment and Training Services",
        content5: "We empower organizations to identify and hire top-tier talent while developing employee capabilities through targeted training programs. Our end-to-end solutions help build high-performing teams and drive continuous professional growth at every level.",
        6: "Infrastructure Services",
        content6: "We build and maintain mission-critical IT infrastructure—networks, cloud, data centers, and security systems—that drive operational resilience and digital growth. Our managed services guarantee uptime, protect data, and optimize performance, freeing your team to focus on strategic initiatives rather than technology maintenance.",
        7: "R&D",
        content7: "At its core, AI builds intelligent models that power applications from predictive analytics to robotics, combining data science with human-like reasoning.",
        img: {
            app: {
                id: "appService",
                1: "Application Development",
                2: "PRINCE",
                3: "Application Maintenance",
                4: "SSADM",
                5: "Security Services"
            },
            con: {
                id: "consultingService",
                1: "Feasibility Study",
                2: "IT Planning",
                3: "Technical Study",
                4: "ISSS",
            },
            transf: {
                id: "transformationService",
                1: "Container/Microservices",
                2: "AWS",
                3: "SCRUM",
                4: "Azure",
                5: "DevOps"
            },
            eCon: {
                id: "eCommerce",
                1: "SAP Hybris",
            },
            recruitTrain: {
                id: "RecruAndTrainService",
                1: "Headhunt and Body Shop Services",
                2: "Talent Coaching and Training",
            },
            infra: {
                id: "InfraStrService",
                1: "Infrastructure Design and Build",
                2: "Product Resell, Distribution and Maintenance",
            },
            rd: {
                id: "RD",
                1: "Artificial Intelligence",
                2: "Robotics",
            },
        },
    }
}

export default ServiceEn;